<template>
  <div class="layout">
    <MainHeader></MainHeader>
    <MainNav @nav-data="getNavData"></MainNav>
    <div class="iv-home-content">
      <router-view :navData="navData"></router-view>
    </div>
    <MainFooter></MainFooter>
  </div>
</template>
<script>
import MainHeader from './main-header'
import MainNav from './main-nav'
import MainFooter from './main-footer'
export default {
  components: { MainHeader, MainNav, MainFooter },
  data () {
    return {
      navData: {}
    }
  },
  created () {
  },
  watch: {
    $route(val) {
      // IE下强制GC
      if (/trident/i.test(navigator.userAgent) && window.CollectGarbage) {
        this.$nextTick(() => {
          window.CollectGarbage()
        })
      }
    }
  },
  methods: {
    getNavData(data) {
      this.navData = data
    }
  }
}
</script>

<style lang="scss">
/*全局样式注入*/
@import '@/assets/css/new-blue/index.scss';

body, html, #app {
  #app {
    font-family: 'PingFang SC', 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #f4f6fa url('~@/assets/images/new-home/top-bj.png') no-repeat;
    background-size: contain;
    height: 100vh !important;
    overflow: hidden;
  }
}

body {
  overflow-x: hidden !important;
  scrollbar-width: thin;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #c2c2c2;
}

::-webkit-scrollbar-track {
  border-radius: 6px;
  background: rgba(250, 250, 250, .9);
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 1920px) {
}
@media screen and (min-width: 1920px) {
}
.iv-home-content {
  min-height: calc(100vh - 381px);
}
</style>